"use client";
import { useCommonContext, usePrescriptionContext } from "@/src/provider";
import { FmPicker } from "@/ui-component";
import React, { useMemo, useState } from "react";
import RxTitle from "../RxTitle";
import stl from "./add.module.scss";
import variable from "@/src/styles/variables.module.scss";
import Help from "../ODOS/Help";
import { IErrorList } from "@/src/productDetails/Rx/RxForm";
import { useTranslation } from "@/src/i18n/client";
interface IAddProps {
    selectData: Record<string, number[]>;
    errors: IErrorList;
    onChange?: () => void;
}
const ADD: React.FC<IAddProps> = (props) => {
    const { errors } = props;
    const { site } = useCommonContext();
    const { t } = useTranslation("lens");
    const [activeData, setPrescription] = usePrescriptionContext((state) => [
        state.activeData,
        state.setPrescription,
    ]);
    const [pickerOpen, setPickerOpen] = useState(false);
    const defaultOption = useMemo(() => {
        return { value: t("lens:Rx.n/a"), label: t("lens:Rx.n/a") };
    }, [t]);
    const aixsData = useMemo(() => {
        const validData = props.selectData["add"].map(
            (item: string | number) => {
                return {
                    label: item,
                    value: item,
                };
            },
        );
        validData.unshift(defaultOption);
        return validData;
    }, [defaultOption, props.selectData]);
    return (
        <div className={stl["add-container"]}>
            <RxTitle title={t("lens:Rx.ADD")} details={t("lens:Rx.Addition")}>
                <Help
                    title={t("lens:Explain.Add")}
                    description={t("lens:Explain.AddList")}
                    image={
                        site != "fm" ? "/__firmoo/static/images/add.jpg" : ""
                    }
                />
            </RxTitle>
            <FmPicker
                borderColor={variable.main}
                error={errors.chooseError.trim().length > 0}
                helperText={errors.chooseError}
                errorPosition="bottom"
                name={"add"}
                inputClassName={stl["picker-wrapper"]}
                dataSource={aixsData}
                open={pickerOpen}
                confirm={"confirm"}
                cancel={"cancel"}
                onChange={(open, value) => {
                    setPickerOpen(open);
                    setPrescription({ add: value as number });
                    props.onChange?.();
                }}
                inputClasses={{
                    outline: stl["outline-div"],
                    inputCount: stl["input-content"],
                }}
                defaultValue={t("lens:Rx.n/a")}
                value={activeData.prescription.add ?? defaultOption.value}
                classes={{ icon: stl["icon"] }}
            ></FmPicker>
            <p className={stl["lens-add"]}>
                {t("lens:prescriptions.ADDIsUsed")}
            </p>
        </div>
    );
};

export default ADD;
